import React, { useMemo } from "react";
import classNames from "classnames";

import { Icon, IconName } from "../Icon";
import styles from "./SocialsList.module.scss";

type SocialItem = {
  link: string;
  icon: IconName;
};

interface SocialsListProps extends React.HTMLAttributes<HTMLUListElement> {
  items: string[];
}

const getIcon = (link: string): IconName => {
  if (link.includes("instagram.com")) {
    return "instagram";
  }
  if (link.includes("facebook.com")) {
    return "facebook";
  }
  if (link.includes("twitter.com")) {
    return "twitter";
  }
  return "website";
};

const SocialsList: React.FC<SocialsListProps> = ({ items, className }) => {
  const expanded = useMemo<SocialItem[]>(() => {
    return items.map(item => {
      return {
        link: item,
        icon: getIcon(item),
      };
    });
  }, [items]);

  return (
    <ul className={classNames(styles.list, className)}>
      {expanded.map(item => (
        <li key={item.link}>
          <a
            className={styles.link}
            href={item.link}
            target="_blank"
            rel="noreferrer noopener"
          >
            <Icon name={item.icon} />
          </a>
        </li>
      ))}
    </ul>
  );
};

export { SocialsList };
